<template>
  <b-container class="mt-4 h-95">
    <b-row class="h-100">
      <b-col class="d-flex flex-column">
        <b-row>
          <b-col class="h3"
            >Extrato das Refeições dos Acompanhantes de Pacientes</b-col
          >
        </b-row>
        <b-row>
          <b-col>
            <b-form>
              <Fieldset legend="Filtros" :toggleable="true" class="px-3 pb-3">
                <b-row>
                  <b-col class="col-2">
                    <label for="prontuario">Prontuário</label>
                    <b-form-input
                      id="prontuario"
                      v-model="prontuario"
                      :state="!$v.prontuario.$error ? null : false"
                    ></b-form-input>
                  </b-col>
                </b-row>
              </Fieldset>
              <b-row class="mt-2">
                <b-col>
                  <b-button
                    variant="success"
                    class="mr-2"
                    @click="buscaInternacoes"
                    >Buscar internações</b-button
                  >
                  <b-button variant="danger" @click="limpar">Limpar</b-button>
                </b-col>
              </b-row>
            </b-form>
          </b-col>
        </b-row>

        <b-row class="mt-2" v-show="!isDisplayingReport">
          <b-col>
            <b-table
              id="tabelaInternacoes"
              :items="internacoes"
              :fields="campos_tabela"
              small
            >
              <template v-slot:cell(dthr_internacao)="row">
                {{ new Date(row.item.dthr_internacao) | moment("L") }}
              </template>
              <template v-slot:cell(dt_saida_paciente)="row">
                {{ new Date(row.item.dt_saida_paciente) | moment("L") }}
              </template>
              <template v-slot:cell(acoes)="row">
                <!-- `data.value` is the value after formatted by the Formatter -->
                <b-row align-h="end" class="mr-1">
                  <b-button
                    @click="geraRelatorioGeral(row.item.seq)"
                    class="mr-2"
                    v-b-tooltip.hover
                    title="Imprime relatório geral"
                    ><i class="fas fa-file-pdf"></i
                  ></b-button>
                  <b-button
                    @click="geraRelatorioConsolidado(row.item.seq)"
                    v-b-tooltip.hover
                    title="Imprime relatório consolidado"
                    ><i class="fas fa-file-pdf"></i
                  ></b-button>
                </b-row>
              </template>
            </b-table>
          </b-col>
        </b-row>

        <b-row class="mt-2 flex-grow-1 h-100" v-show="isDisplayingReport">
          <b-col>
            <embed
              :src="src"
              width="100%"
              type="application/pdf"
              height="100%"
            />
          </b-col>
        </b-row>
        <b-row class="mt-2">
          <b-col>
            <b-button
              v-show="isDisplayingReport"
              variant="primary"
              @click="isDisplayingReport = !isDisplayingReport"
              >Voltar</b-button
            >
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import Fieldset from "primevue/fieldset";
import { required } from "vuelidate/lib/validators";

export default {
  data() {
    return {
      src: "",
      prontuario: null,
      isDisplayingReport: false,
      internacoes: [],
      campos_tabela: [
        { key: "seq", label: "ID" },
        { key: "dthr_internacao", label: "Data de internação" },
        { key: "dt_saida_paciente", label: "Data de saída" },
        { key: "acoes", label: "Ações", thClass: "cabecalho-direita" },
      ],
    };
  },
  components: {
    Fieldset,
  },
  methods: {
    geraRelatorioGeral(seq) {
      if (!this.$v.$invalid) {
        this.$http({
          url: `/extratodepacientes/relatoriogeral/${seq}`,
          responseType: "blob",
        }).then((response) => {
          var blob = new Blob([response.data], {
            type: "application/pdf",
          });
          var url = window.URL.createObjectURL(blob);
          this.src = url;
        });

        this.isDisplayingReport = true;
      }
    },
    geraRelatorioConsolidado(seq) {
      if (!this.$v.$invalid) {
        this.$http({
          url: `/extratodepacientes/relatorioconsolidado/${seq}`,
          responseType: "blob",
        }).then((response) => {
          var blob = new Blob([response.data], {
            type: "application/pdf",
          });
          var url = window.URL.createObjectURL(blob);
          this.src = url;
        });

        this.isDisplayingReport = true;
      }
    },
    limpar() {
      this.internacoes = [];
      this.prontuario = "";
      this.isDisplayingReport = false;
    },
    buscaInternacoes() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.$http({
          url: `/internacoesporprontuario/${this.prontuario}`,
        }).then((response) => {
          this.internacoes = response.data;
          console.log(this.internacoes);
        });
      }
    },
  },
  validations: {
    prontuario: {
      required,
    },
  },
};
</script>

<style strict>
.p-fieldset-legend {
  width: auto !important;
  font-size: 1rem !important;
}
.h-90 {
  height: 90%;
}
.h-95 {
  height: 95%;
}
</style>
